export default [
	{
		path: '/account/subscription/cancel-additional',
		name: 'account-subscription-cancel-additional',
		component: () =>
			import(
				/* webpackChunkName: "manage-subscription" */ '@/views/account/manage-subscription/CancelAdditionalSubscription.vue'
			),
		meta: {
			requiresAuth: true,
			requiresUser: true,
			hideProgress: true
		}
	},

	{
		path: '/account/subscription/one-year-offer',
		name: 'account-subscription-one-year-offer',
		props: { scenarioId: 'one-year-offer' },
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/subscription/AccountSubscription'),
		meta: {
			requiresUser: true,
			requiresSubscription: true,
			requiresUserFlags: true
		}
	},

	{
		path: '/account/subscription/pausing-email',
		name: 'account-subscription-pausing-email',
		props: { scenarioId: 'pausing-email' },
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/subscription/AccountSubscription'),
		meta: {
			requiresUser: true,
			requiresSubscription: true,
			requiresUserFlags: true
		}
	},

	{
		path: '/account/subscription/one-quarter-offer-cancellation',
		name: 'account-subscription-one-quarter-offer-cancellation',
		props: { scenarioId: 'one-quarter-offer-cancellation' },
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/subscription/AccountSubscription'),
		meta: {
			requiresUser: true,
			requiresSubscription: true,
			requiresUserFlags: true
		}
	},

	{
		path: '/account/subscription/workbooks-plus-three-months-for-free',
		name: 'workbooks-plus-three-months-for-free',
		props: { scenarioId: 'workbooks-plus-three-months-for-free' },
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/subscription/AccountSubscription'),
		meta: {
			requiresUser: true,
			requiresSubscription: true,
			requiresUserFlags: true
		}
	},

	{
		path: '/account/subscription/additional-subscription-cancellation',
		name: 'additional-subscription-cancellation',
		props: { scenarioId: 'additional-subscription-cancellation' },
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/subscription/AccountSubscription'),
		meta: {
			requiresUser: true,
			requiresSubscription: true,
			requiresUserFlags: true
		}
	},

	{
		path: '/account/subscription/subscription-pause-3-months',
		name: 'account-subscription-pause-3-months',
		props: { scenarioId: 'subscription-pause-3-months' },
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/subscription/AccountSubscription'),
		meta: {
			requiresUser: true,
			requiresSubscription: true,
			requiresUserFlags: true
		}
	},
	{
		path: '/account/subscription/subscription-pause-1-month',
		name: 'account-subscription-pause-1-month',
		props: { scenarioId: 'subscription-pause-1-month' },
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/subscription/AccountSubscription'),
		meta: {
			requiresUser: true,
			requiresSubscription: true,
			requiresUserFlags: true
		}
	}
]
